import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import { rhythm } from '../utils/typography'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Heading from '../components/Heading'
import TriRoundRow from '../components/TriRoundRow'
import CenterRow from '../components/CenterRow'
import Divider from '../components/Divider'
import CTAButton from '../components/CTAButton'
import Hero from '../components/Hero'
import LeadForm from '../components/LeadForm'
import '../css/applications.less'

class ApplicationsPage extends React.Component {
  render () {
  	const pages = [ ...this.props.route.pages ]
    const path = this.props.route.page.path

  	const meta = {
  		description: "ACS acoustic cleaners (sonic horns) are effective in a wide range on industry applications including, but not limited too: SCR's, ESP's, Boilers, Fabric Filters, ID Fans, Dryers, Silos, and Hoppers. We service customers in several custom applications as well.",
  		keywords: "Acoustic Cleaning Systems",
  		headline: "ACS Applications: We have your application covered.",
  		title: "ACS Applications: We have your application covered."
  	}

    return (
      <div className="">
        <Helmet
          title={`${meta.title}`}
          meta={[
            { name: "Description", content: `${meta.description}`},
            { name: "Keywords", content: `${meta.keywords}`},
            { property: "og:title", content: `${meta.headline}`},
            { property: "og:description", content: `${meta.description}`},
            { property: "og:type", content: "article"},
            { property: "og:url", content: `${config.rootUrl}${path}`},
            { name: "twitter:card", content: "summary_large_image"},
            { name: "twitter:site", content: `${config.twitterHandle}` },
            { name: "twitter:creator", content: `${config.twitterHandle}` },
            { name: "twitter:title", content: `${meta.title}` },
            { name: "twitter:description", content: `${meta.description}` }
          ]}
        />
				<Hero headline='Our horns are a sound investment.'
					className="applications"
					images={[
						'/images/hero/1.jpg',
						'/images/hero/2.jpg',
						'/images/hero/0.jpg',
					]}
				>
					<LeadForm />
				</Hero>
				<div className="container page installations-page">
					<br /><br />
					<CenterRow headline="Our horns are effective in numerous applications.">
						Acoustic cleaners provide an effective solution to buildup and
						material flow problems within a wide range of industries.
					</CenterRow>
          <Divider />
					<div className="row center-xs">
            <div className="col-xs-12 col-sm-6 col-md-5 left-col">
							<h2>Selective Catalytic Reduction</h2>
              <p>
								Acoustic Cleaning Systems, Inc. has become the vendor of choice for acoustic cleaners within
								the utilities industry. Acoustic energy is a viable and effective technique to clean SCR catalyst
								and has been spec’d in on new SCR’s since the late 1990’s. The acoustic energy emitted by the
								acoustic cleaners is non-erosive to the catalyst modules. ACS has supplied 1000’s of acoustic
								cleaners for SCR applications and with the introduction of the Magnum has simply blown their
								competition away!
              </p>
							<h2><br/>Electrostatic Precipitators</h2>
							<p>
								Sonic horns are proven alternatives to supplement and in some cases completely replace
								mechanical rapping systems on collection surfaces, electrode wires, and inlet distribution
								plates. Elimination of hopper pluggage can be achieved by installing units in the hoppers
								typically on a pokehole. Acoustic cleaning improves efficiency, increases precipitator uptime,
								reduces precipitator maintenance, and may prevent grounding problems. Sonic horns also
								effectively clean turning vanes.
							</p>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-7 first-xs last-sm">
							<img src="/images/applications-scr.jpg" />
            </div>
          </div>

					<br /><br />
					<br /><br />
					<div className="row center-xs">
						<div className="col-xs-12 col-sm-6 col-md-7">
							<img src="/images/applications-boiler.jpg" />
						</div>
						<div className="col-xs-12 col-sm-6 col-md-5 right-col">
							<h2>Heat Transfer Surfaces &amp; Boilers</h2>
              <p>
								Acoustic cleaning is a proven alternative to conventional steam sootblowers in boilers burning
								fossil fuels and waste fuels. Acoustic cleaners can be used to supplement and even replace
								steam sootblowers in certain applications. Units have been applied in superheaters, generating
								sections, economizers, horizontal re-heat, and airheaters. Advantages of acoustic cleaning
								include reduction or elimination of opacity spikes due to more frequent cleaning, reduction of
								steam sootblower cycles for steam savings, and lower maintenance costs.
              </p>
							<h2><br/>Fabric Filters &amp; Elements</h2>
							<p>
								Acoustic Cleaners are a proven method for cleaning in reverse air and shaker type baghouses.
								The units are effective in reducing pressure drop, increasing bag life, decreasing manual
								cleaning, and reducing hopper pluggage. There are also potential applications in Pulse Jet
								Collectors – Cleaning of the elements if the compartments can be isolated – and in the hoppers.
							</p>
						</div>
					</div>

					<Divider />
					<CenterRow headline="Other Applications" />
					<div className="row center-xs">
						<div className="col-xs-12 col-sm-6 col-md-4 center-col">
							<h2>ID Fans</h2>
							<img src="/images/applications-id-fan.jpg" />
							<p>
								ACS acoustic cleaners can be applied to eliminate out of balance conditions, clean inaccessible
								parts, create a uniform cleaning pattern, and reduce the frequency of manual cleaning.
								Acoustic cleaning may also reduce fan horsepower requirements.
							</p>
						</div>
						<div className="col-xs-12 col-sm-6 col-md-4 center-col">
							<h2>Dryers</h2>
							<img src="/images/applications-economizer.jpg" />
							<p>
								Acoustic energy is a successful way to eliminate unwanted buildup on walls of spray dryers and
								reduce product cave-in's. Acoustic Cleaners also aid in the discharge of products from RVDs
								(rotary vacuum dryers), tumbling, fluidbed, tray, and pan dryers between batch changeouts.
							</p>
						</div>
					</div>
					<div className="row center-xs">
						<div className="col-xs-12 col-sm-6 col-md-4 center-col">
							<h2><br/><br/>Hoppers</h2>
							<img src="/images/applications-silo.jpg" />
							<p>
								ACS acoustic cleaners have been applied to eliminate ratholing problems, bridging problems
								occurring in hoppers, and buildup on vertical walls. Sonic horns are successful in fluidizing a
								variety of products ranging from flour to fly ash. Other advantages include increased product
								flow and elimination of structural damage caused by vibrators.
							</p>
						</div>
						<div className="col-xs-12 col-sm-6 col-md-4 center-col">
							<h2><br/><br/>Custom Applications</h2>
							<img src="/images/applications-custom.jpg" />
							<p>
								We're continually searching for new applications for our acoustic cleaner product line. Let our
								technical team analyze the factors specific to your application. With our extensive field
								experience in the application and installation of acoustic cleaners, we will custom design an
								acoustic cleaning system that is most effective for you.
							</p>
						</div>
					</div>
					<Divider />
					<Heading text="Our horns aren't limited to the applications above. Companies from all sorts of industries are finding our products save them time and money while reducing the need for regular maintenance." />
					<div className="current-clients">
						<div className="row">
							<div className="col-md-3 col-xs-6">
								<p>Cosmetic</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Waste to Energy Plants</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Food Processing</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Detergent</p>
							</div>
						</div>
						<div className="row">
							<div className="col-md-3 col-xs-6">
								<p>Flour</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Power Generation</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Material Handling</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Smelting</p>
							</div>
						</div>
						<div className="row">
							<div className="col-md-3 col-xs-6">
								<p>Chemical</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Wood Processing</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Pharmaceutical</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Refinery</p>
							</div>
						</div>
						<div className="row">
							<div className="col-md-3 col-xs-6">
								<p>Cement</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Gypsum</p>
							</div>
							<div className="col-md-3 col-xs-6">
								<p>Steel Industry</p>
							</div>
						</div>
					</div>
				</div>
    	</div>
    )
  }
}

ApplicationsPage.propTypes = {}
ApplicationsPage.defaultProps = {}
ApplicationsPage.data = {
  menuLabel: 'Applications',
  menuShortDescription: 'Applications for Acoustic Cleaning Services, Inc.'
}
export default ApplicationsPage



// WEBPACK FOOTER //
// ./applications.js